import { FC, ReactNode } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface GridSectionHeroProps {
  className?: string;
  rightImg?: string;
  heading?: ReactNode;
  subHeading?: string;
  btnText?: string;
  imgHeight?: string;
  imgWidth?: string;
}

const GridSectionHero: FC<GridSectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
  imgWidth,
  imgHeight,
}) => {
  return (
    <div className={`nc-SectionHero relative ${className}`} data-nc-id="SectionHero">
      <div className="relative grid items-center grid-cols-1 text-center lg:grid-cols-2 lg:text-left lg:gap-x-20">
        <div className="flex justify-center mb-8 lg:justify-end lg:mb-0 relative group">
          <div className="relative overflow-hidden rounded-3xl transform group-hover:scale-105 transition-transform duration-500">
            <img
              className="w-full object-cover"
              src={rightImg || ""}
              alt="Event To Bee"
              style={{ width: imgWidth, height: imgHeight }}
            />
          </div>
        </div>

        <div className="w-full space-y-6 xl:max-w-2xl lg:space-y-8">
          <div className="p-6 bg-white dark:bg-neutral-800 rounded-2xl border border-neutral-200 dark:border-neutral-700">
            <p className="text-lg leading-relaxed text-neutral-700 dark:text-neutral-300 font-medium">{heading}</p>
          </div>

          <div className="p-6 bg-gradient-to-br from-primary-50 to-secondary-50 dark:from-neutral-800 dark:to-neutral-700 rounded-2xl border border-primary-200 dark:border-neutral-600">
            <p className="text-lg leading-relaxed text-neutral-700 dark:text-neutral-300">{subHeading}</p>
          </div>

          {!!btnText && (
            <div className="pt-4">
              <ButtonPrimary
                href="/login"
                className="px-8 py-4 bg-gradient-to-r from-primary-500 to-secondary-500 text-white font-semibold rounded-full transform hover:scale-105 transition-all duration-300"
              >
                {btnText}
              </ButtonPrimary>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GridSectionHero;
